import InputStatusModule from "./inputStatusModule";

export default InputStatusModule;



// WEBPACK FOOTER //
// ./lib/ts/modules/inputStatus/index.ts